//ntl
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/constants/navigation/B6H5XQ21PPCM/menu/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import flashdeal from "@/navigation/flashdeal";
import luckyDraw from "@/navigation/lucky-draw";

//ntl
import horoscope from "@/constants/navigation/B6H5XQ21PPCM/menu/horoscope";
import friendReferral from "@/constants/navigation/B6H5XQ21PPCM/menu/friend-referral";
import mission from "@/constants/navigation/B6H5XQ21PPCM/menu/mission";
import lottery from "@/constants/navigation/B6H5XQ21PPCM/menu/lottery";
import ntlArticle from "@/constants/navigation/B6H5XQ21PPCM/menu/ntl-article";
import survey from "@/constants/navigation/B6H5XQ21PPCM/menu/survey";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVhekqhqR2M9pO":
      switch (decodeToken()?.sub) {
        case "ID_Nt5ewewAFW0O":
          return [
            ...dataManagement,
            ...banner,
            ...mission,
            ...horoscope,
            ...ntlArticle,
            ...survey,
            ...friendReferral,
            ...lottery,
            ...report,
          ];
      }
      return [...dataManagement, ...fulfillment];
    case "PVNBJHWuCByaOU":
      return [...report, ...fulfillment];
    default:
      return [
        ...dataManagement,
        ...banner,
        ...mission,
        ...horoscope,
        ...ntlArticle,
        ...survey,
        ...friendReferral,
        ...lottery,
        ...privileges,
        ...fulfillment,
        ...inventory,
        ...document,
        ...flashdeal,
        ...tags,
        ...report,
        ...luckyDraw
      ];
  }
};

export default renderNavByPermission();
